import React from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const ProfileMenuItem = ({ href, icon, text, color, onClick }) => {
  const isDanger = color === "red";
  return (
    <Box
      component={href ? "a" : "div"}
      href={href || undefined}
      onClick={onClick}
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "14px 16px",
        borderRadius: "18px",
        marginBottom: "10px",
        background: "rgba(255,255,255,0.03)",
        border: "1px solid rgba(255,255,255,0.06)",
        cursor: "pointer",
        textDecoration: "none",
        boxSizing: "border-box",
        transition: "all 0.22s ease",
        "&:hover": {
          background: isDanger ? "rgba(255,76,76,0.06)" : "rgba(0,212,255,0.05)",
          borderColor: isDanger ? "rgba(255,76,76,0.3)" : "rgba(0,212,255,0.2)",
          transform: "translateX(5px)",
        },
      }}
    >
      <Box sx={{
        width: 44,
        height: 44,
        borderRadius: "13px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: isDanger
          ? "rgba(255,76,76,0.1)"
          : "linear-gradient(135deg, rgba(0,212,255,0.12), rgba(123,47,247,0.12))",
        border: isDanger
          ? "1px solid rgba(255,76,76,0.2)"
          : "1px solid rgba(0,212,255,0.15)",
        mr: 2,
        color: isDanger ? "#ff5555" : "#00d4ff",
        flexShrink: 0,
        "& svg": { fontSize: "1.25rem" },
      }}>
        {icon}
      </Box>
      <Typography sx={{
        flex: 1,
        fontWeight: 500,
        fontSize: "0.95rem",
        color: isDanger ? "#ff5555" : "rgba(255,255,255,0.85)",
        fontFamily: "inherit",
      }}>
        {text}
      </Typography>
      {!isDanger && (
        <ChevronRightIcon sx={{ color: "rgba(255,255,255,0.2)", fontSize: "1.2rem" }} />
      )}
    </Box>
  );
};

export default ProfileMenuItem;

